export interface PartnerBookingSlotPayload {
  venueId: string;
  /** The provider's court (CourtReserve) or court group (PodPlay pod). */
  providerResourceId: string;
  /** Set only when the player picked a specific court. */
  providerCourtId?: string | null;
  /** Venue-local, YYYY-MM-DD. */
  localDate: string;
  /** Venue-local, HH:mm. */
  startLocal: string;
  durationMinutes: number;
  playerCount: number;
}

export interface PostRequestPayload extends PartnerBookingSlotPayload {
  /** A card saved against the player's Stripe customer via a SetupIntent. */
  paymentMethodId: string;
  /** Browser timezone and locale, checked against the account before any charge. */
  clientTimezone?: string;
  clientLocale?: string;
}

export interface PostResponsePayload {
  orderId: string;
  marker: string;
  status: string;
  /** What the player pays, priced on the server. */
  orderTotalUnitAmount: number;
  /** Stripe's intent status; "requires_capture" means the card is held, not charged. */
  paymentStatus: string;
}

export const PARTNER_BOOKINGS_CHECKOUT_API = 'v1/partner-bookings/checkout';
